export class productEnum {
    static MATHLETICS = { id: 1, name: 'Mathletics' };
    static SPELLODROME = { id: 3, name: 'Spellodrome' };
    static INTOSICENCE = { id: 6, name: 'Intoscience' };
    static PHONICS = { id: 8, name: 'Phonics' };
}

export const privacySettingSaveRequestEnum = {
    SCHOOL_COUNTRY: 'school-country',
    SCHOOL_LOCALE: 'school-locale',
    NAME_FORMAT: 'name-format'
};

export const configurationValuesEnum = {
    CONTACT_US_URL: 'ContactUsUrl'
};

export const utcDateFormats = {
    'DD-MM-YYYY': 'DD-MM-YYYY',
    YYYY: 'YYYY'
};




// WEBPACK FOOTER //
// ./app/helpers/enums.js